module.exports = __webpack_public_path__ + "assets/img/16_1807_big.72636f04.jpg";